import { Pipe, PipeTransform } from '@angular/core';


const emptyValue = (value: any) =>
    typeof value === 'undefined' || value === null
    || value === ''
    || (Array.isArray(value) && value.length === 0)
    || typeof value === 'object' && Object.keys(value).length === 0;


@Pipe({
    name: 'default',
})
export class DefaultPipe implements PipeTransform {

    transform(value: any, defaultValue: any) {
        return emptyValue(value) ? defaultValue : value;
    }
}
